import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

const LEGACY_DEFAULT_AVATAR_URL = "https://github.com/yusufhilmi.png";

type ProfileAvatarProps = {
  name?: string;
  src?: string | null;
  className?: string;
  fallbackClassName?: string;
  imageClassName?: string;
};

const getInitials = (name?: string) => {
  const normalizedName = name?.trim() || "Admin";

  return normalizedName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
};

const normalizeAvatarUrl = (src?: string | null) => {
  const trimmedSource = src?.trim();

  if (!trimmedSource || trimmedSource === LEGACY_DEFAULT_AVATAR_URL) {
    return "";
  }

  return trimmedSource;
};

export function ProfileAvatar({
  name,
  src,
  className,
  fallbackClassName,
  imageClassName,
}: ProfileAvatarProps) {
  const normalizedName = name?.trim() || "Admin";
  const normalizedSource = normalizeAvatarUrl(src);

  return (
    <Avatar className={cn("border-2 border-[#C59A4A] shadow-md", className)}>
      {normalizedSource ? (
        <AvatarImage
          src={normalizedSource}
          alt={normalizedName}
          className={imageClassName}
        />
      ) : null}
      <AvatarFallback
        className={cn(
          "bg-gradient-to-br from-[#001D12] to-[#002818] text-[#F7E3B0] font-bold",
          fallbackClassName
        )}
      >
        {getInitials(normalizedName)}
      </AvatarFallback>
    </Avatar>
  );
}

export { LEGACY_DEFAULT_AVATAR_URL, normalizeAvatarUrl };